import apiService from '../config/apiService';

interface UserAutocompleteResult {
  id: string;
  text: string;
  selected_text: string;
}

interface UsersResponse {
  results: UserAutocompleteResult[];
}

const getImpersonationUsers = async (
  query: string
): Promise<UserAutocompleteResult[]> => {
  try {
    if (!query || query.trim().length < 2) {
      return [];
    }

    const response = await apiService.get<UsersResponse>(
      `/impersonation-user-autocomplete/?q=${encodeURIComponent(query.trim())}`
    );

    return response.data.results || [];
  } catch (error) {
    console.error('Error fetching users:', error);

    return [];
  }
};

export default getImpersonationUsers;
